import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';

export async function fetchAssetDetails(assetId: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/details/${assetId}`;
  const response = await get(requestUrl);
  return response;
}
